import { defaultIconProps, IconProps } from './IconProps';

export const IconChevronUp: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path xmlns="http://www.w3.org/2000/svg" d="M18 15L12 9L6 15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconChevronUp.defaultProps = defaultIconProps;
